import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'groceries',
  size: 24,
  node: [
    ['path', { d: 'M10 15h4', key: '192ueg' }],
    [
      'path',
      {
        d: 'M19.424 11.095a2.5 2.5 0 00.471-2.309 2 2 0 00.424-3.286 2 2 0 00-2.143-3.322 2 2 0 00-.676.502 2 2 0 00-3.287.424 2.5 2.5 0 00-3.189 2.06A3 3 0 0012 11l4-4',
        key: 'ioa4ee',
      },
    ],
    [
      'path',
      {
        d: 'M4 12.006A1 1 0 014.994 11H19a1 1 0 011 1v7a2 2 0 01-2 2H6a2 2 0 01-2-2z',
        key: '1y761e',
      },
    ],
    ['path', { d: 'M7 11a4 4 0 01-4-4V5a1 1 0 011-1h2a4 4 0 013.584 2.222', key: 'g173vy' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Groceries
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTVoNCIgLz4KICA8cGF0aCBkPSJNMTkuNDI0IDExLjA5NWEyLjUgMi41IDAgMDAuNDcxLTIuMzA5IDIgMiAwIDAwLjQyNC0zLjI4NiAyIDIgMCAwMC0yLjE0My0zLjMyMiAyIDIgMCAwMC0uNjc2LjUwMiAyIDIgMCAwMC0zLjI4Ny40MjQgMi41IDIuNSAwIDAwLTMuMTg5IDIuMDZBMyAzIDAgMDAxMiAxMWw0LTQiIC8+CiAgPHBhdGggZD0iTTQgMTIuMDA2QTEgMSAwIDAxNC45OTQgMTFIMTlhMSAxIDAgMDExIDF2N2EyIDIgMCAwMS0yIDJINmEyIDIgMCAwMS0yLTJ6IiAvPgogIDxwYXRoIGQ9Ik03IDExYTQgNCAwIDAxLTQtNFY1YTEgMSAwIDAxMS0xaDJhNCA0IDAgMDEzLjU4NCAyLjIyMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/groceries
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Groceries = createLucideIcon(__iconData);

export default Groceries;
